//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import ThePreferences from "../components/ThePreferences";

export default {
  name: "Setting",
  data() {
    return {
      colors: [],
      BaseColor: []
    };
  },
  components: {
    ThePreferences,
  },
  methods: {
    ...mapActions("layout", ["updateSetting"])
  },
  computed: {
    ...mapGetters("layout", ["setting"]),
    dra: {
      get: function () {
        return this.setting;
      },
      set: function () {
        this.updateSetting;
      }
    },
    accent: {
      get: function () {
        return this.$vuetify.theme.dark
          ? this.$vuetify.theme.themes.dark.accent
          : this.$vuetify.theme.themes.light.accent;
      },
      set: function (newValue) {
        if (this.$vuetify.theme.dark) {
          this.$vuetify.theme.themes.dark.accent = newValue;
        } else {
          this.$vuetify.theme.themes.light.accent = newValue;
        }
      }
    },
    primary: {
      get: function () {
        return this.$vuetify.theme.dark
          ? this.$vuetify.theme.themes.dark.primary
          : this.$vuetify.theme.themes.light.primary;
      },
      set: function (newValue) {
        if (this.$vuetify.theme.dark) {
          this.$vuetify.theme.themes.dark.primary = newValue;
        } else {
          this.$vuetify.theme.themes.light.primary = newValue;
        }
      }
    }
  }
};
